SAPO.Project.Video.thumbs = { // http://trac.intra.sapo.pt/thumbs/wiki/ManualDeUtilizacao

    transformFrame: function(videoDims, duration, imgDims) {
        if (!imgDims) {
            imgDims = [560, 420];
        }

        //printReq(videoDims, duration, imgDims);

        var orig_width  = videoDims[0]; // px
        var orig_height = videoDims[1];
        var time        = isFinite(duration) ? duration : 2; // s
        var width       = imgDims[0]; // thumbnail
        var height      = imgDims[1];

        var orig_calculate_ratio = (4 * orig_height / orig_width, 1).toFixed(1);

        if (orig_calculate_ratio === '3.2' || orig_calculate_ratio === '3.3') {
            orig_width = ~~( orig_height * 4 / 3 );
        }

        var new_height = ~~(orig_height * width / orig_width);
        var new_width = width;

        if (new_height > height) {
            new_height = height;
            new_width = ~~(orig_width * height / orig_height);
        }

        if (time > 300){
            time = 300;
        }

        var pad, padx, pady, pos = Math.floor(time / 4);

        if (new_width > width){
            new_width = new_width - (new_width % 2);
        }
        else {
            new_width = new_width + (new_width % 2);
        }

        if (new_width !== width){
            pad = width - new_width;
            padx = Math.floor( pad / 2 );
            pady = 0;
        }

        if (new_height > height){
            new_height = new_height - (new_height % 2);
        }
        else {
            new_height = new_height + (new_height % 2);
        }

        //if (new_height !== height){
            pad = height - new_height;
            padx = 0;
            pady = Math.floor( pad / 2 );
        //}

        pad = [padx, pady];
        var dims = [new_width, new_height];

        //console.log('->');
        //printResp(dims, pad, pos);

        return {
            dims: dims,
            pad:  pad,
            pos:  pos
        };
    },

	crop: function(imgUrl, dims, offset) {

        //console.log('crop', imgUrl, dims.join('x'), offset.join('x'));

		// TODO REMOVE IN PROD
		//var key = 'O que tu queres sou EU!';
		//var hash = SAPO.Utility.md5(imgUrl + key);

		var url = [
			'//thumbs.web.sapo.io/?p=', imgUrl,
			//'//thumbs.sapo.pt/?p=', encodeURIComponent(imgUrl),
			//'&h=', hash, // TODO REMOVE IN PROD
			'&W=', dims[0],
			'&H=', dims[1],
			//'&Q=',  // quality, entre 0-100, default 80
			'&errorpic=transparent',//, errorUrl or transparent
            '&crop=corner_lt',
            '&cropcoords=', offset[0], 'x', offset[1]
		].join('');
		return url;
	},

    cropPosterTransform: function(imgUrl, imgDims, videoDims, duration) {
        if (!videoDims) { return imgUrl; }

        var o = SAPO.Project.Video.thumbs.transformFrame(videoDims, duration, imgDims);

        /*console.log('videoDims: %d x %d', videoDims[0], videoDims[1]);
        console.log('duration:  %d',      duration);
        console.log('imgDims:   %d x %d', imgDims[0],   imgDims[1]);
        console.log('->');
        console.log('dims:      %d x %d', o.dims[0],    o.dims[1]);
        console.log('pad:       %d x %d', o.pad[0],     o.pad[1]);
        console.log('pos:       %d',      o.pos);*/

        // CORRECT TRANSFORM
        var dims = [
            imgDims[0] - o.pad[0] * 2,
            imgDims[1] - o.pad[1] * 2,
        ];

        // FAULTY TRANSFORM
        /*var dims = [
            o.dims[0] - o.pad[0] * 2,
            o.dims[1] - o.pad[1] * 2,
        ];*/

        var imgUrl2 = SAPO.Project.Video.thumbs.crop(imgUrl, dims, o.pad);

        /*console.log('dims\':    %d x %d', dims[0],  dims[1]);
        console.log('img url\': %s', imgUrl2);*/

        return imgUrl2;
    }

};
